import parentPath from '../path'

export const scriptPath = `${parentPath}/script`;
export default scriptPath;
